import React from "react";
import { classNames } from "../../helpers";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";

export default function TwPopover(props) {
  const { children, buttonContent, buttonClassName = "", className = "", error = false } = props

  return (
    <Popover className="relative">
      <PopoverButton className={classNames("", buttonClassName)}>
        {buttonContent}
      </PopoverButton>


      <PopoverPanel anchor="bottom end" className={classNames("absolute z-10 mt-2 [min-w-48] min-w-32 bg-white shadow-lg rounded-lg [p-4]", className)}>
        {children}
      </PopoverPanel>
    </Popover>
  );
}
